module.exports = __webpack_public_path__ + "static/media/rpn-dark.b31ceb7e.png";